import { createBrowserHistory } from "history";

/* React-Router provides a useHistory hook that can be used by react components */
/* createBrowserHistory allows us to access history in non react components, */
/* but we have to be careful to always use this history object. */
/* E.g. this is used in the login flow, where we want to redirect on a successful login */

export const history = createBrowserHistory();
